export const PAGES_BASE_URL = '/v1/pages';
export const ALL_PAGES_URL = `${PAGES_BASE_URL}/all`;
export const TEMPLATES_URL = `${PAGES_BASE_URL}/templates`;
export const TEMPLATE_BY_ID_URL = `${PAGES_BASE_URL}/templates/:id`;
export const PAGE_BY_ID_URL = `${PAGES_BASE_URL}/:id`;
export const GENERATE_CONTENTS_PAGE_URL = `${PAGES_BASE_URL}/generate/contents/page`;
